/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import classnames from 'classnames';

import IconArrowRight from './icons/IconArrowRight';
import CircleWithBorder from './CircleWithBorder';

import COLORS from '../styles/Colors';

interface Props {
  onClick(): void;
  isDisabled: boolean;
  theme: string;
  direction: 'horizontal' | 'down';
  fillColor: string;
  triggerFlash: boolean;
}

const ArrowWithCircle = (props: Props) => {
  let circleClassName = '';

  switch (props.theme) {
    case 'group':
      circleClassName = 'theme-group base fill';
      break;
    case 'backpack':
      circleClassName = 'fill-color-backpack-theme-accent';
      break;
    case 'profile':
    default:
      circleClassName = '';
      break;
  }

  if (props.triggerFlash) {
    circleClassName += ' util-animated-fill-flash';
  }

  return (
    <div className={classnames('cmp-arrowwithcircle', { 'is-disabled': props.isDisabled, clickable: !!props.onClick })} onClick={props.onClick}>
      <div className="touch-area-centering">
        <CircleWithBorder
          size={34}
          strokeColor="white"
          fillColor={props.fillColor}
          className={circleClassName}
        />
        <div className={classnames('cmp-arrowwithcircle-arrow', props.direction)}>
          <IconArrowRight.Medium color="white" />
        </div>
      </div>
    </div>
  );
};

export const RightArrowWithCircle = (props) => (
  <ArrowWithCircle fillColor={COLORS.enabledOverlayProfileColor} {...props} direction="horizontal" />
);

export const DownArrowWithCircle = (props) => (
  <ArrowWithCircle fillColor={COLORS.enabledOverlayProfileColor} {...props} direction="down" />
);

export default ArrowWithCircle;
